/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setLoyaltyNotificationPreference} from '../api'

export const useMutationSetLoyaltyNotificationPreference = createReactQueryMutationHook('setLoyaltyNotificationPreference', setLoyaltyNotificationPreference)
